import { useTranslations } from 'next-intl';

import { ReviewItem as ReviewProps } from '@silvertours/common-landingpages-view';
import { UiLegacy } from '@silvertours/front-legacy-shared';
import { Ui } from '@silvertours/front-shared';

import { RatingGroups } from './RatingGroups';
import {
  ReviewContainer,
  ReviewFooter,
  QuoteContainer,
  ArrowUpIcon,
} from './Reviews.styles';
import { ReviewHeader } from './ReviewHeader';
import { useReviewItem } from './useReviewItem';

const ExpandedReviewItem = (props: ReviewProps) => {
  const t = useTranslations('features.trustLegacy.feedback.reviewItem');

  const { providerQuote, ratingGroups, onClose, siteQuote } = props;
  const {
    header,
    host,
    providersQuoteTitleLabel,
    reviewerLabel,
    siteQuoteTitleLabel,
  } = useReviewItem(props);

  return (
    <ReviewContainer>
      <ReviewHeader {...header} />
      <QuoteContainer>
        <UiLegacy.PlainText>
          <b>{siteQuoteTitleLabel}</b>
        </UiLegacy.PlainText>
        <UiLegacy.Quote>{siteQuote}</UiLegacy.Quote>
        <UiLegacy.PlainText>
          <b>{providersQuoteTitleLabel}</b>
        </UiLegacy.PlainText>
        <UiLegacy.Quote>{providerQuote.quote}</UiLegacy.Quote>
      </QuoteContainer>

      <RatingGroups
        ratingGroups={ratingGroups}
        providerQuote={providerQuote}
        host={host}
      />

      <ReviewFooter>
        <UiLegacy.TinyText>{reviewerLabel}</UiLegacy.TinyText>
        <Ui.TextLink as="button" onClick={onClose}>
          {t('readLess')}
          <ArrowUpIcon />
        </Ui.TextLink>
      </ReviewFooter>
    </ReviewContainer>
  );
};

export { ExpandedReviewItem };
